const childRoutes = prop => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    },
    {
        path: 'hospital-information',
        name: prop + '.hospital_information',
        meta: { auth: true },
        component: () => import('../pages/hospital-information/List.vue')
    },
    {
        path: 'direct-donation',
        name: prop + '.direct_donation',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/direct-donation/List.vue')
    },
    {
        path: 'rehabilitation',
        name: prop + '.rehabilitation',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/rehabilitation/List.vue')
    },
    {
        path: 'rehabilitation-form/:id?',
        name: prop + '.rehabilitation_form',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/rehabilitation/Form.vue')
    },
     {
        path: 'social-service-delivery',
        name: prop + '.social_service_delivery',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/social-service-delivery/List.vue')
    },
    {
        path: 'case-history',
        name: prop + '.case_history',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/case-history/List.vue')
    },
    {
        path: 'case-history-list',
        name: prop + '.case_history_list',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/case-history-list/List.vue')
    },
    {
        path: 'followup',
        name: prop + '.followup',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/followup/List.vue')
    },
    {
        path: 'followup-list',
        name: prop + '.followup_list',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/followup-list/List.vue')
    },
    {
        path: 'hospital-top-sheet-report',
        name: prop + '.hospital_top_sheet_report',
        meta: { auth: true },
        component: () => import('../pages/reports/hospital-top-sheet-report/List.vue')
    },
    {
        path: 'date-wise-hospital-report',
        name: prop + '.date_wise_hospital_report',
        meta: { auth: true },
        component: () => import('../pages/reports/date-wise-hospital-report/List.vue')
    },
    {
        path: 'hospital-report',
        name: prop + '.hospital_report',
        meta: { auth: true },
        component: () => import('../pages/reports/hospital-report/List.vue')
    },
    {
        path: 'hospital-sub-total-report',
        name: prop + '.hospital_sub_total_report',
        meta: { auth: true },
        component: () => import('../pages/reports/hospital-sub-total-report/List.vue')
    },
    {
        path: 'cash-flow-report',
        name: prop + '.cash_flow_report',
        meta: { auth: true },
        component: () => import('../pages/reports/cash-flow-report/List.vue')
    },
    {
        path: 'monthly-progress-financial-reports',
        name: prop + '.monthly_progress_financial_reports',
        meta: { auth: true },
        component: () => import('../pages/reports/mrfs/List.vue')
    },
    {
        path: 'monthly-progress-report',
        name: prop + '.monthly_progress_report',
        meta: { auth: true },
        component: () => import('../pages/reports/monthly-progress-report/List.vue')
    },
    {
        path: 'date-range-base-all-hospital-progress-report',
        name: prop + '.date_range_base_all_hospital_progress_report',
        meta: { auth: true },
        component: () => import('../pages/reports/all-hospital-progress-report/List.vue')
    },
    {
        path: 'date-range-base-progress-report',
        name: prop + '.date_range_base_progress_report',
        meta: { auth: true },
        component: () => import('../pages/reports/weekly-progress-report/List.vue')
    },
    {
        path: 'panel-donation-report',
        name: prop + '.panel_donation_report',
        meta: { auth: true },
        component: () => import('../pages/reports/panel-donation-report/List.vue')
    },
    {
        path: 'monthly-progress-financial-report',
        name: prop + '.monthly_progress_financial_report',
        meta: { auth: true },
        component: () => import('../pages/reports/monthly-progress-financial-report/List.vue')
    },
    {
        path: 'yearly-progress-financial-report',
        name: prop + '.yearly_progress_financial_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-progress-financial-report/List.vue')
    },
    {
        path: 'monthly-progress-numeric-report',
        name: prop + '.monthly_progress_numeric_report',
        meta: { auth: true },
        component: () => import('../pages/reports/monthly-progress-numeric-report/List.vue')
    },
    {
        path: 'yearly-progress-numeric-report',
        name: prop + '.yearly_progress_numeric_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-progress-numeric-report/List.vue')
    },
    {
        path: 'income-register',
        name: prop + '.income_register',
        meta: { auth: true },
        component: () => import('../pages/reports/income-register/List.vue')
    },
    {
        path: 'material-distribution-report',
        name: prop + '.material_distribution_report',
        meta: { auth: true },
        component: () => import('../pages/reports/material-distribution-report/List.vue')
    },
    {
        path: 'social-service-patient-report',
        name: prop + '.social_service_patient_report',
        meta: { auth: true },
        component: () => import('../pages/reports/social-service-patient-report/List.vue')
    },
    {
        path: 'financial-aid-report',
        name: prop + '.financial_aid_report',
        meta: { auth: true },
        component: () => import('../pages/reports/financial-aid-report/List.vue')
    },
    {
        path: 'bnswc-report',
        name: prop + '.bnswc_report',
        meta: { auth: true },
        component: () => import('../pages/reports/bnswc-report/List.vue')
    },
    {
        path: 'followup-info-add',
        name: prop + '.followup_list',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/followup/Form.vue')
    },
    {
        path: 'case-history-add/:case_id?',
        name: prop + '.case_history_add',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/case-history/CaseHistoryMain.vue')
    },
    {
        path: 'followup-info-details',
        name: prop + '.followup_list',
        meta: { auth: true },
        component: () => import('../pages/follow-up-management/followup/Details.vue')
    },
    {
        path: 'social-service-delivery-add',
        name: prop + '.social_service_delivery_add',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/social-service-delivery/Form.vue')
    },
    {
        path: 'social-service-delivery-details',
        name: prop + '.social_service_delivery_details',
        meta: { auth: true },
        component: () => import('../pages/delivery-management/social-service-delivery/Details.vue')
    },
    {
        path: 'other-reports',
        name: prop + '.other_reports',
        meta: { auth: true },
        component: () => import('../pages/reports/other-reports/List.vue')
    },
    {
        path: 'burnt-victim-assistance-report',
        name: prop + '.burnt_victim_assistance_report',
        meta: { auth: true },
        component: () => import('../pages/reports/burnt-victim-assistance-report/List.vue')
    },
    {
        path: 'hospital-report-upazila',
        name: prop + '.hospital_report_upazila',
        meta: { auth: true },
        component: () => import('../pages/reports/hospital-report-upazila/List.vue')
    },
    {
        path: 'patient-entry-live-report',
        name: prop + '.patient_entry_live_report',
        meta: { auth: true },
        component: () => import('../pages/reports/patient-entry-live-report/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/social-service',
        name: 'hospital_disability_service.social_service',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.social-service')
    }
]

export default routes
